import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Instagram, Facebook, Youtube } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-ink text-brand-cream border-t border-brand-cream/10" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-6">
            <div className="font-serif italic text-[10px] tracking-[0.3em] text-brand-yellow">est. 1972</div>
            <div className="font-serif text-2xl md:text-3xl mt-2">
              BANDENG <span className="italic text-brand-red">Primaroso</span>
            </div>
            <p className="mt-4 font-sans text-sm text-brand-cream/60 max-w-md italic">
              {t.footer.tagline}
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="font-sans text-[10px] tracking-[0.3em] uppercase text-brand-cream/40 mb-4">Contact</div>
            <p className="font-sans text-sm text-brand-cream/70 leading-relaxed">{t.footer.address}</p>
            <p className="font-sans text-sm text-brand-cream/70 mt-2">+62 878 7873 1755</p>
            <p className="font-sans text-sm text-brand-cream/70 mt-2">+62 896 8220 1008</p>
            <p className="font-sans text-sm text-brand-cream/70">hello@primaroso.com</p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="font-sans text-[10px] tracking-[0.3em] uppercase text-brand-cream/40 mb-4">Follow</div>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 border border-brand-cream/20 rounded-full flex items-center justify-center hover:border-brand-yellow hover:text-brand-yellow transition-colors" data-testid="social-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 border border-brand-cream/20 rounded-full flex items-center justify-center hover:border-brand-yellow hover:text-brand-yellow transition-colors" data-testid="social-facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 border border-brand-cream/20 rounded-full flex items-center justify-center hover:border-brand-yellow hover:text-brand-yellow transition-colors" data-testid="social-youtube">
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-brand-cream/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-sans text-xs tracking-[0.15em] text-brand-cream/40">
            © {year} BANDENG PRIMAROSO. {t.footer.rights}
          </p>
          <p className="font-sans text-xs tracking-[0.15em] text-brand-cream/40">
            Made with care in Semarang, Indonesia.
          </p>
        </div>
      </div>
    </footer>
  );
};
